module.exports = __webpack_public_path__ + "static/media/main.983e3e68.png";